import { i18n } from '@bamboohr/utils/lib/locale';
import { setDateFnsLocale } from './set-date-fns-locale';

export const configureDateFnsOnLanguageChange = () => {
	i18n.on('languageChanged', (lang: string) => {
		setDateFnsLocale(lang);
	});
};
